import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
//import Button from '@mui/material/Button';
//import {Tools} from './Tools';
import {Owner} from './Inc';
import useStyles from './Styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
//import ColInput from './ColInput';
import {Theme} from './Theme';

interface TakebackSuccessProps {
	isOpen:boolean,
    owner:Owner,
    close(): void,
}

const TakebackSuccess = (props:TakebackSuccessProps)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	if(!props.isOpen){
		return (null);
	}

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color="primary">商品引取</DialogTitle>
			<DialogContent>
				<div className={classes.confirmGuide}>
				商品引取の申請をうけたまわりました。<br/>
				在庫の確認を行った上で、送料や発送日をメールでお知らせいたします。1営業日程度お待ち下さい。<br/>
				<br/>
				数日経過しても架空ストアからの連絡がない場合は、お手数ですがお問い合わせフォームなどでご一報をお願いいたします。<br/>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} bottom={0}/>
			</DialogActions>
		</Dialog>
	);
}

export default TakebackSuccess;
